export default "__VITE_ASSET__dd24d834__"